import { render, staticRenderFns } from "./DetailEnrollClass.vue?vue&type=template&id=1e12c6e0"
import script from "../../services/teacher/detail-enroll-class.js?vue&type=script&lang=js&external"
export * from "../../services/teacher/detail-enroll-class.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports